import { ElementSpec } from './ElementSpec';

// Runtime data associated with an Edge in the Doc graph
export class EdgeSpec extends ElementSpec {}
